/* Animace - vlastni implementace.
   Tlacitko zpet nahoru resi samostatny vh-top.js, aby ho nemohla
   shodit pripadna chyba zde. */
(function () {
  if (window.__vhAnim) return;
  window.__vhAnim = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DEFAULT_OPTS = { rootMargin: '0px 0px -8% 0px', threshold: 0.12 };

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function observe(els, cb, opts) {
    if (!('IntersectionObserver' in window)) { els.forEach(cb); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { io.unobserve(e.target); cb(e.target); }
      });
    }, opts || DEFAULT_OPTS);
    els.forEach(function (el) { io.observe(el); });
  }

  function all(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  onReady(function () {
    /* zpozdeni pro skupiny */
    all('[data-vh-stagger]').forEach(function (group) {
      var step = parseInt(group.getAttribute('data-vh-stagger'), 10) || 90;
      Array.prototype.forEach.call(group.children, function (child, i) {
        var t = child.hasAttribute('data-vh-reveal') ? child : child.querySelector('[data-vh-reveal]');
        if (t) t.style.setProperty('--vh-delay', (i * step) + 'ms');
      });
    });

    /* odkryvani */
    var reveal = all('[data-vh-reveal]');
    all('[data-vh-reveal-children]').forEach(function (parent) {
      Array.prototype.forEach.call(parent.children, function (child, i) {
        child.style.transitionDelay = Math.min(i, 8) * 60 + 'ms';
        reveal.push(child);
      });
    });
    if (reduce) reveal.forEach(function (el) { el.classList.add('vh-in'); });
    else observe(reveal, function (el) { el.classList.add('vh-in'); });

    /* pocitadla */
    all('[data-vh-count]').forEach(function (el) {
      var raw = (el.getAttribute('data-vh-count') || '').trim();
      var m = raw.match(/^([^0-9]*)([0-9][0-9\s.,]*)(.*)$/);
      if (!m) { el.textContent = raw; return; }
      var pre = m[1];
      var suf = m[3];
      var target = parseInt(m[2].replace(/[^0-9]/g, ''), 10);
      if (!isFinite(target) || reduce) { el.textContent = raw; return; }
      el.textContent = pre + '0' + suf;
      observe([el], function () {
        var dur = 1700;
        var t0 = null;
        function tick(now) {
          if (t0 === null) t0 = now;
          var p = Math.min(1, (now - t0) / dur);
          var v = Math.round(target * (1 - Math.pow(1 - p, 3)));
          el.textContent = pre + v + suf;
          if (p < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
      }, { threshold: 0.4 });
    });

    /* psani po pismenech */
    all('[data-vh-type]').forEach(function (el) {
      var text = el.getAttribute('data-vh-type') || '';
      if (reduce) { el.textContent = text; el.classList.add('is-done'); return; }
      el.textContent = '';
      observe([el], function () {
        var i = 0;
        (function step() {
          el.textContent = text.slice(0, ++i);
          if (i < text.length) setTimeout(step, 48);
          else el.classList.add('is-done');
        })();
      }, { threshold: 0.25 });
    });

    /* stridani slov */
    all('[data-vh-switch]').forEach(function (el) {
      var words = (el.getAttribute('data-vh-switch') || '').split('|').map(function (s) {
        return s.trim();
      }).filter(Boolean);
      if (!words.length) return;
      el.textContent = '';
      var spans = words.map(function (w, i) {
        var s = document.createElement('span');
        s.className = 'vh-switch__word' + (i === 0 ? ' is-active' : '');
        s.textContent = w;
        el.appendChild(s);
        return s;
      });
      requestAnimationFrame(function () {
        var max = 0;
        spans.forEach(function (s) { max = Math.max(max, s.getBoundingClientRect().width); });
        if (max) el.style.minWidth = Math.ceil(max) + 'px';
      });
      if (reduce || spans.length < 2) return;
      var idx = 0;
      setInterval(function () {
        spans[idx].classList.remove('is-active');
        idx = (idx + 1) % spans.length;
        spans[idx].classList.add('is-active');
      }, 2600);
    });

    /* podtrzeni nadpisu */
    all('[data-vh-highlight]').forEach(function (el) {
      var style = el.getAttribute('data-vh-highlight');
      if (!style || style === 'none') return;
      var NS = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('viewBox', '0 0 300 20');
      svg.setAttribute('preserveAspectRatio', 'none');
      svg.setAttribute('aria-hidden', 'true');
      var path = document.createElementNS(NS, 'path');
      path.setAttribute('d', style === 'straight' ? 'M5 12 L295 12' : 'M6 16 C80 2, 220 2, 294 11');
      svg.appendChild(path);
      el.appendChild(svg);
      var len = 500;
      try { len = Math.ceil(path.getTotalLength()) + 6; } catch (e) {}
      el.style.setProperty('--vh-hl-len', len);
      if (reduce) { el.classList.add('vh-in'); return; }
      observe([el], function () { el.classList.add('vh-in'); }, { threshold: 0.4 });
    });

    /* slider recenzi */
    all('[data-vh-slider]').forEach(function (root) {
      var slides = all('.vh-review', root);
      if (slides.length < 2) return;
      var idx = 0;
      var btn = root.querySelector('[data-vh-slider-next]');
      if (!btn) return;
      btn.addEventListener('click', function () {
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      });
    });
  });
})();
